import React from 'react';
import Button from './Button';

const Modal = ({ isOpen, onClose, title, children, showCloseButton = false }) => {
  if (!isOpen) return null;

  return (
    <div className='modal-overlay' onClick={onClose}>
      <div className='modal-content' onClick={(e) => e.stopPropagation()}>
        {title && (
          <div className='modal-header'>
            <h3>{title}</h3>
            <button className='modal-close-button' onClick={onClose}>
              ×
            </button>
          </div>
        )}
        <div className='modal-body'>
          {children}
        </div>
        {showCloseButton && (
          <div className='modal-footer'>
            <Button onClick={onClose}>
              Close
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
